import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTimer } from '../contextes/useTimer';
import SoundIcon from './SoundIcon';

// Props du composant MissionHeader
type MissionHeaderProps = {
    showBackButton?: boolean;
    backButtonVariant?: 'primary' | 'tertiary' | 'secondary';
    showSettingsButton?: boolean;
    showCloseButton?: boolean;
    logoVariant?: 'default' | 'alternate' | 'dark';
    closeFunction?: () => void;
    closeButtonVariant?: 'primary' | 'tertiary' | 'white';
    showTimer?: boolean;
    timerVariant?: 'default' | 'sombre';
    showSoundIcon?: boolean;
    soundButtonVariant?: 'primary' | 'tertiary';
};

// Composant pour l'en-tête des écrans de mission
// Affiche le logo, les boutons de navigation, le timer et l'icône sonore

const MissionHeader: React.FC<MissionHeaderProps> = ({
    showBackButton = true,
    showSettingsButton = true,
    showCloseButton = false,
    logoVariant = 'default',
    closeFunction,
    closeButtonVariant = 'primary',
    showTimer = true,
    timerVariant = 'default',
    showSoundIcon = true,
    backButtonVariant = 'primary',
    soundButtonVariant = 'primary',
}) => {
    const navigate = useNavigate();
    const handleSettingsClick = () => {
        // if()
        navigate('/parametres', { state: { isSettingButtonClicked: true } });
    };
    // Récupère le temps restant depuis le contexte Timer
    const { time, formatTime } = useTimer();

    return (
        <div
            className='mission-header-container'
            style={{
                justifyContent: showBackButton
                    ? 'space-between'
                    : showTimer || showSoundIcon
                      ? 'space-between'
                      : 'flex-end',
            }}
        >
            {/* Affichage du bouton back si showBackButton est vrai */}
            {showBackButton ? (
                <div
                    className='button-container-header'
                    onClick={() => navigate('/')}
                >
                    <div className='button-shadow'></div>
                    <button
                        className={`button-header ${backButtonVariant === 'tertiary' ? 'button-vert-fonce' : 'button-vert-clair'}`}
                    >
                        <img
                            src='./images/back-icon.png'
                            alt='Back Icon'
                            className='button-header-icon'
                        />
                    </button>
                </div>
            ) : showTimer ? (
                <div
                    className={`header-timer ${
                        timerVariant === 'sombre' ? 'header-timer-sombre' : 'header-timer-clair'
                    }`}
                >
                    {formatTime(time)} <p>Temps restant</p>
                </div>
            ) : null}

            <div className={`sound-container-div  ${showTimer ? 'absolute' : ''}`}>
                {!showTimer && <div className='button-shadow'></div>}
                {/* Importation du component SoundIcon pour affichage de l'icône sonore */}
                <SoundIcon
                    isTransparent={showTimer}
                    buttonVariant={soundButtonVariant}
                />
            </div>
            <img
                src={`./images/${
                    logoVariant === 'alternate'
                        ? 'logo-alternate'
                        : logoVariant === 'dark'
                          ? 'logo-dark'
                          : 'logo'
                }.png`}
                alt='Logo FBI'
                className='header-logo'
                style={{ alignSelf: 'center' }}
            />

            {/* Affichage du bouton paramètres si showSettingsButton est vrai */}
            {showSettingsButton && (
                <div
                    className='button-container-header'
                    onClick={handleSettingsClick}
                >
                    <div className='button-shadow'></div>
                    <button className={`button-vert-clair button-header`}>
                        <img
                            src='./images/settings-icon.png'
                            alt='Settings Icon'
                            className='button-header-icon'
                        />
                    </button>
                </div>
            )}

            {/* Affichage du bouton close si showCloseButton est vrai */}
            {showCloseButton && (
                <div
                    className='button-container-header'
                    onClick={closeFunction ? closeFunction : () => navigate(-1)}
                >
                    <div
                        className={`button-shadow${
                            closeButtonVariant === 'white' ? '-alternate' : ''
                        }`}
                    ></div>
                    <button
                        className={`${
                            closeButtonVariant === 'primary'
                                ? 'button-vert-fonce'
                                : closeButtonVariant === 'tertiary'
                                  ? 'button-vert-clair'
                                  : 'button-white'
                        } button-header`}
                    >
                        <img
                            src={`./images/close-icon${
                                closeButtonVariant === 'white' ? '-alternate' : ''
                            }.png`}
                            alt='Close Icon'
                            className='button-header-icon'
                        />
                    </button>
                </div>
            )}
        </div>
    );
};

export default MissionHeader;
